module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAANCAYAAAB/9ZQ7AAAAAXNSR0IArs4c6QAAAOBJREFUKFOt0rFKA0EQBuD5wb1a3yCtkC6W+gCCRVoxxRY3i5AX8AUEX8HZ5iwEe7WyuS5tuhRXpMkDWAY28MtCAnd6xhRu+3/DzO4OVPUVwJX0HJJrALdm9pRjhBBoZujDOSO52ha8H4KHAGqSkw723g+cc1FEzkVkDuBMRI5yV5KfHayqMxF5SSk9FkUxFZGxmV1knEf6jj+aprms63rjvT92zi1jjCe9eHfJsixHAO4AbMzsei8OISSSDyml+6qq1n/hhZmdtp/zx8y7UFVvYozP/49/+03s2412Ecm3LyVTmAx3AcP8AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/businessTicketDiscount/icon_wenti.png
// module id = wSmV
// module chunks = 69